export interface BookingParticipantDisplay {
  _id: string;
  name: string;
  avatar: string | null;
  status: "Confirmed" | "Accepted" | "Pending" | "Selected";
  removable: boolean;
}

export function playerIdentity(value: any): string {
  return String(value?._id ?? value ?? "");
}

function playerDisplay(
  value: any,
  status: BookingParticipantDisplay["status"],
  removable: boolean,
): BookingParticipantDisplay | null {
  const id = playerIdentity(value);
  if (!id) return null;
  const configuredName = String(value?.name ?? "").trim();
  const email = String(value?.email ?? "").trim();
  return {
    _id: id,
    name: configuredName || email || "Unavailable participant",
    avatar: value?.avatar || value?.picture || null,
    status,
    removable,
  };
}

export function buildBookingParticipantDisplay(
  booking: any,
  selectedPlayers: any[],
): BookingParticipantDisplay[] {
  const participants = new Map<string, BookingParticipantDisplay>();
  const add = (value: any, status: BookingParticipantDisplay["status"], removable = false) => {
    const player = playerDisplay(value, status, removable);
    if (!player) return;
    const existing = participants.get(player._id);
    if (!existing || existing.status === "Selected" || status === "Confirmed") {
      participants.set(player._id, player);
    }
  };

  (booking?.playersList || []).forEach((player: any) => add(player, "Confirmed"));
  (booking?.invitations || []).forEach((invitation: any) => {
    const invitedPlayer =
      typeof invitation.invitedUser === "object"
        ? invitation.invitedUser
        : {
            _id: invitation.invitedUser,
            email: invitation.invitedEmail,
          };
    if (invitation.status === "accepted") add(invitedPlayer, "Accepted");
    if (invitation.status === "pending") add(invitedPlayer, "Pending");
  });
  selectedPlayers.forEach((player) => add(player, "Selected", true));
  return [...participants.values()];
}
